import { ElementMenuItem } from '../elementMenuItem';
import store from '@/store';
import Element, { ElementType, SpecyficType } from '../element';
import { slotsManager } from '../slotsManager';
import { messager } from '../messager';
import { i18n } from '@/plugins/i18n';
import { Vector2 } from '@babylonjs/core';

interface Test {
    without: (e: Element) => boolean;
    subject?: (e: ElementMenuItem) => ElementMenuItem;
    message: string;
}

interface ElementTest {
    for: (e: ElementMenuItem) => boolean;
    tests: Test[];
}

class HintsManager {

    private readonly elementTests: ElementTest[] = [{
        for: (e) =>
            e.type === ElementType.FRONT &&
            e.subElements.length > 0,
        tests: [{
            without: (e) =>
                e.specyficType === SpecyficType.VERTICAL_WALL,
            message: 'doubleDoorsDoNotFitInFrontOfVerticalWalls',
        }, {
            without: (e) =>
                e.specyficType === SpecyficType.HORIZONTAL_WALL &&
                e.shape.x === 2,
            message: 'doorBlockedByHorizontalWall',
        }, {
            without: () => false,
            subject: (e) => e.subElements[0],
            message: 'doubleDoorsDoNotFitTrySinglwDoors',
        }],
    }, {
        for: (e) =>
            e.type === ElementType.FRONT &&
            e.subElements.length === 0,
        tests: [{
            without: (e) => false,
            subject: (e) => ({
                ...e,
                shape: new Vector2(e.shape.x * 2, e.shape.y),
                subElements: [
                    { ...e },
                    { ...e },
                ],
            }),
            message: 'singleDoorsDoNotFitTryDoubleDoors',
        }],
    }, {
        for: (e) => e.type === ElementType.FRONT,
        tests: [{
            without: (e) =>
                e.specyficType === SpecyficType.HORIZONTAL_WALL &&
                e.shape.x === 1,
            message: 'doorBlockedByHorizontalWall',
        }, {
            without: (e) =>
                (e.specyficType === SpecyficType.HORIZONTAL_WALL &&
                    e.shape.x === e.shape.x) ||
                e.specyficType === SpecyficType.DRAWER ||
                e.specyficType === SpecyficType.DRAWER_FRONT,
            message: 'drawersDoNotHideBehindFronts',
        }],
    }, {
        for: (e) => e.type === ElementType.INSIDE,
        tests: [{
            without: (e) => e.specyficType === SpecyficType.HANGER,
            message: 'hangersReserveSomeSpace',
        }],
    }, {
        for: (e) => e.specyficType === SpecyficType.DRAWER,
        tests: [{
            without: (e) => e.specyficType === SpecyficType.SHELF,
            message: 'drawersDoNotFitBetweenShelf',
        }, {
            without: (e) =>
                e.specyficType === SpecyficType.REGULAR_FRONT,
            message: 'tooLongFrontForDrawer',
        }],
    }];

    public showHint() {
        const element: ElementMenuItem = store.getters.scene
            .selectedElementMenuItem;
        for (const elementTest of this.elementTests) {
            if (elementTest.for(element)) {
                for (const test of elementTest.tests) {
                    const subject = test.subject
                        ? test.subject(element)
                        : element;
                    if (slotsManager.createSlots(
                        subject,
                        test.without,
                    ).length) {
                        const m = i18n.t(test.message).toString();
                        messager.info(m);
                        return;
                    }
                }
            }
        }
        const message = i18n.t('noSlotsAvailable').toString();
        messager.info(message);
    }
}

export const hintsManager = new HintsManager();
